<template>
  <footer :class="{ fixed: this.isFixed }">  
    <div class="col-xs-12 col-sm-12 col-md-10 col-md-offset-1">
        <div class="row">
            <div class="col-xs-12 col-md-6 col-lg-4 logo">
                <span @click="$router.push({ name: 'Home' })"></span>
                <img class="aftrhrs" src="/static/images/aftrhrs.png" />
            </div>
            <div class="col-xs-12 col-md-6 col-lg-4 info">
                <div class="info-box">
                    <h4 class="follow">{{ footer.follow }}</h4>
                    <ul class="social">
                        <li class="instagram"><a target="_blank" :href="social.instagram" v-if="social.instagram">Instagram</a></li>
                        <li class="spotify"><a target="_blank" :href="social.spotify" v-if="social.spotify">Spotify</a></li>
                        <li class="facebook"><a target="_blank" :href="social.facebook" v-if="social.facebook">Facebook</a></li>
                        <li class="twitter"><a target="_blank" :href="social.twitter" v-if="social.twitter">Twitter</a></li>
                        <li class="youtube"><a target="_blank" :href="social.youtube" v-if="social.youtube">Youtube</a></li>
                    </ul>
                    <p class="contact">
                        <a class="email" :href="`mailto:${footer.email}`" v-if="footer.email" :class="{center:!footer.phone}">{{ footer.email }}</a>
                        <span class="spacer" v-if="footer.phone">|</span>
                        <a v-if="footer.phone" class="phone" :href="`tel:${footer.phone}`">{{ footer.phone }}</a>
                    </p>
                </div>
            </div>
            <div class="col-xs-12 col-md-6 col-lg-4 copyright">
                <span v-html="footer.copyright"></span>
                <a :href="cookiesLink" target="_blank">cookies policy</a>
                <a :href="privacyLink" target="_blank">privacy policy</a>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-6 col-md-offset-6 col-lg-4 col-lg-offset-4 eat">
                <a href="http://weareeat.com/" target="_blank">EAT</a>
            </div>
        </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  dependencies: ['DATA'],
  data () {
    return {
      footer: this.DATA.configs.footer,
      social: this.DATA.configs.social,
      cookiesLink: `https://www.musicalfreedom.com/uploads/${this.DATA.configs.footer.cookiesPolicy.filename}`,
      privacyLink: `https://www.musicalfreedom.com/uploads/${this.DATA.configs.footer.privacyPolicy.filename}`,
      isFixed: false
    }
  },
  watch: {
    isFixed(value) {
        if (value) {
            let rect = this.$el.getBoundingClientRect().top;
            TweenMax.set(this.$el, { y: rect});
        } else {
            TweenMax.set(this.$el, {y: 0})
        }
    }
  },
  mounted() {
    this.$bus.$on('holdScreen', () => {
      this.isFixed = true;
    })
    this.$bus.$on('releaseScreen', () => {
      this.isFixed = false;
    })
  }
}
</script>

<style scoped lang="scss">
@import '../scss/variables';
footer {
    background: $black;
    color: $white;
    padding-top: 60px;

    &.fixed {
        position: fixed;
        width: 100%;
        top: 0px;
    }

    .logo {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .logo span {
        background-image: url('/static/images/logo.svg');
        background-repeat: no-repeat;
        background-size: contain;
        width: 150px;
        height: 64px;
        display: block;
        cursor: pointer;
        filter: invert(100%);
    }

    .aftrhrs {
        width: 80px;
        position: relative;
        flex-grow: 0;
        flex-shrink: 0;
        margin: 0px 40px;
    }

    .info {
        padding-top: 10px;
        @media screen and (min-width: 64em) {
            .info-box {
                width: 350px;
                display: block;
                margin: 0 auto;
            }
        }
    }

    .follow {
        float: left;
        line-height: 45px;
        margin-right: 2vw;
        font-size: 14px;
    }

    .social {
        float: left;
        font-size: 14px;

        li {
            display: inline;
            &.instagram a {
                background-image: url('/static/images/instagram.svg');
            }
            &.spotify a {
                background-image: url('/static/images/spotify.svg');
            }
            &.facebook a {
                background-image: url('/static/images/facebook.svg');
            }
            &.twitter a {
                background-image: url('/static/images/twitter.svg');
            }
            &.youtube a {
                background-image: url('/static/images/youtube.svg');
                margin-right: 0;
            }

            a {
                filter: invert(100%);
                display: inline-block;
                background-size: cover;
                background-repeat: no-repeat;
                width: 20px;
                height: 20px;
                text-indent: -99em;
                overflow: hidden;
                margin-right: 20px;
                margin-right: 20px;
                margin-top: 10px;
                &:hover {
                    transform: scale(1.1);
                    transition: transform .2s $easeOutBack;
                }
            }
        }
    }

    .contact {
        float: left;
        width: 100%;
        max-width: 350px;
        font-size: 13px;
        border-top: 2px solid $white;

        padding: 0 5px;
        margin-left: -5px;

        a {
            text-decoration: none;
            color: $white;
            float: left;
            margin: 10px 0;
        }

        .center {
            width: 100%;
            text-align: center;
        }

        .spacer {
            margin: 10px;
            float: left;
        }
    }

    .copyright {
        margin: 20px auto;
        font-size: 13px;
        line-height: 2em;
        text-align: center;
        white-space: nowrap;
        display: flex;
        flex-direction: column;
        a {
            color: #fff;
        }
    }

    .eat {
        padding: 20px 0;
        a {
            display: block;
            margin: 0 auto;
            width: 20px;
            height: 20px;
            background: url('/static/images/eat.png') 50% no-repeat;
            background-size: cover;
            text-indent: -99em;
            overflow: hidden;
            transition: transform .2s $easeInBack;

            &:hover {
                background-image: url('/static/images/eat-hover.png');
                transform: scale(1.25);
            }
        }
    }

    @media screen and (max-width: 1750px) {
        .contact {
            border-top: none;
            .spacer {
                display: none;
            }
        }
        .copyright {
            text-align: center;
        }
    }

    @media screen and (max-width: 64em) {
        .contact {
            margin-top: 20px;
            max-width: 100%;
            a {
                width: 100%;
                text-align: center;
            }
        }
        .logo {
            justify-content: center;
        }
        .follow {
            float: inherit;
            text-align: center;
        }
        .social {
            float: inherit;
            display: block;
            margin: 0 auto;
            width: 195px;
        }
        .copyright {
            text-align: center;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue